import { request } from '../../services/RestClient';
import { getJwtToken } from '../../redux/utils/user';
import { setAuthenticatedCookies } from '../../redux/utils/cookies';
import ServiceUrl from '../../utils/ServiceUrl';

const authenticateOnMononoth = () =>
  request({
    method: 'get',
    url: `${ServiceUrl.public('noths')}/session/authenticated`,
    withCredentials: true,
  });

export const authenticateUserWithNoths = async () => {
  const jwtToken = await getJwtToken();
  setAuthenticatedCookies(jwtToken);
  await authenticateOnMononoth();
};
